module.exports = __webpack_public_path__ + "img/loading.27b9019a.svg";